import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '../../../shared/cn'

export const LightCard = ({
  children,
  className,
  ...props
}: {
  children: ReactNode
  className?: string
} & HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={cn(
        'h-fit rounded-xl border border-borderPrimary bg-backgroundPrimary p-6',
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}
